<template>
  <div class="app-view-video">
    <div
      class="app-video-url-main"
      :class="{ 'app-view-content-info': disabled }"
    >
      <div class="app-video-url-bg" @click="viewVideoInfo()">
        <div class="app-video-url-bg-icon">
          <div>
            <i class="bx bxs-hand-up"></i>
            <p>点击查看视频</p>
          </div>
        </div>
      </div>

      <div>
        <template v-if="src.indexOf('.m3u8') == -1">
          <video v-if="disabled" :src="src"></video>
          <video v-if="!disabled" controls="controls" :src="src"></video>
        </template>
        <xb-player
          v-if="src.indexOf('.m3u8') != -1"
          :src="src"
          height="auto"
          width="300px"
          :autoplay="false"
        ></xb-player>
      </div>
    </div>
  </div>
</template>

<script>
import XbPlayer from "@/components/player/XbPlayer.vue";
export default {
  components: {
    XbPlayer,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      url: "",
    };
  },

  mounted() {},

  methods: {
    viewVideoInfo() {
      let that = this;
      this.contentModal({
        title: "视频详情",
        src: that.src,
        type: "video",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-view-video .app-video-url-main {
  border: 1px solid #ced4da;
  width: 300px;
  background-image: url(../../assets/images/default_cover_1_1.png);
  background-size: 100% 100%;
}

.app-view-video .app-video-url-main video {
  width: 100%;
  display: block;
}

.app-view-video .app-view-content-info {
  position: relative;
  z-index: 999;
}

.app-view-video .app-video-url-bg {
  position: absolute;
  /* background-color: transparent; */
  background-color: rgb(192, 196, 204, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  cursor: pointer;
  display: none;
}

.app-view-video .app-view-content-info .app-video-url-bg {
  display: block;
}

.app-view-video .app-video-url-bg:hover {
  background-color: rgb(192, 196, 204, 0.7);
}

.app-view-video .app-video-url-bg:hover .app-video-url-bg-icon {
  display: block;
}

.app-view-video .app-video-url-bg .app-video-url-bg-icon {
  width: 100%;
  height: 100%;
  position: relative;
  display: none;
}

.app-view-video .app-video-url-bg .app-video-url-bg-icon div {
  position: absolute;
  top: 50%;
  left: 0px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
}

.app-view-video .app-video-url-bg i {
  /*border: 2px solid #fff;*/
  font-size: 45px;
  color: #fff;
  /*border-radius: 50%;*/
}

.app-view-video .app-video-url-bg p {
  color: #fff;
  font-size: 15px;
  margin-bottom: 0;
  margin-top: 10px;
}
</style>
